import React from 'react';

interface CardProfileBasicInfoItemProps {
  title: string;
  value: string;
}

const CardProfileBasicInfoItem = ({ title, value }: CardProfileBasicInfoItemProps) => {
    return (
        <div className='grid'>
            <span className="text-gray-400 leading-none">{ title }</span>
            <span className="font-semibold leading-none">{ value }</span>
        </div>
    )
}

export default CardProfileBasicInfoItem;